import { localStorage as local } from '@entrata/utils'
import { ERRORS_STORAGE_KEY } from 'portal-modules/common/constants/keys'

/**
 * Stashes errors in `localStorage` for later submission.
 * @param {object} error The error object to stash
 */
export default error =>
  new Promise(resolve => {
    setTimeout(() => {
      const errors = local.get(ERRORS_STORAGE_KEY) || []
      local.set(ERRORS_STORAGE_KEY, [...errors, error])
      resolve('success')
    }, 0)
  })
